import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/home/client.tsx");
